import React, { useEffect, useState, useRef, useMemo } from "react";
import axios from "axios";

import { useParams, Link } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import jsPDF from "jspdf";
import moment from "moment";
import JsBarcode from "jsbarcode";
import html2canvas from "html2canvas";
import { toastError, toastSuccess } from "../../../common/Toast";
import { DATA_EXPORT, ERROR_MESSAGE } from "../../../common/Constant";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { AgGridReact } from "ag-grid-react";
import { useCallback } from "react";
import * as XLSX from "xlsx";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "../../../assets/css/customersummary.css";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import Moment from "moment";

//--------Material React Table------//
import { MaterialReactTable } from "material-react-table";
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

const currentDate = new Date();
const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const month = monthNames[currentDate.getMonth()]; // add 1 to get month value from 1 to 12
const hours = currentDate.getUTCHours();
const minutes = currentDate.getUTCMinutes();

const CustomerContactList = (props) => {
  const gridRef = useRef();
  const token = localStorage.getItem("Token");

  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalSum, setTotalSum] = useState(0);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [activeAccordion, setActiveAccordion] = useState(null);

  // ----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });

  const ITEMS_PER_PAGE = 10;

  const barcodeRefs = useRef([]);
  let index = 0;
  const [data, setData] = useState({
    inputValue: "",
    width: 1,
    height: 20,
    fontSize: 15,
    zeroFill: 10,
  });

  //Function to generate barcode
  const generateBarcodes = () => {
    barcodeRefs.current.forEach((barcodeRef, index) => {
      console.log("barcodeRefs", barcodeRefs);
      var g = document.getElementsByTagName(barcodeRef);
      const barcodeValue = paramObject.id;
      console.log("barcodeValue", barcodeValue);
      const paddedBarcodeValue = barcodeValue.padStart(data.zeroFill, "0");
      JsBarcode(barcodeRef, paddedBarcodeValue, {
        width: data.width,
        height: data.height,
        fontSize: data.fontSize,
        displayValue: true,
        fontoptions: "bold",
        textAlign: "center",
        font: "monospace",
        textPosition: "bottom",
        textMargin: 2,
        margin: 10,
        marginTop: undefined,
        marginBottom: undefined,
        marginLeft: undefined,
        marginRight: undefined,
        format: "CODE128",
        valid: () => true,
        background: "#ffffff",
        lineColor: "#000000",
        padding: data.zeroFill,
      });
    });
  };

  const callback = (payload, enddate2) => {
    setStartDate(payload);
    setEndDate(enddate2);
  };
  // let columnDefs = [
  //   { headerName: "Customer", field: "Customer", minWidth: 130 },
  //   { headerName: "PHONE NUMBERS", field: "PhoneNumbers", minWidth: 130 },
  //   { headerName: "EMAIL", field: "Email", minWidth: 160 },
  //   { headerName: "BILLING ADDRESS", field: "BillingAddress", minWidth: 180 },
  //   { field: "ShippingAddress", headerName: "SHIPPING ADDRESS", minWidth: 160 },
  // ];

  //---------------------Material React Table------------------//
  const columns = useMemo(() => [
    {
      header: "Customer",
      accessorKey: "Customer",
      // enableGrouping: false, //do not let this column be grouped
    },
    {
      header: "PHONE NUMBERS",
      accessorKey: "PhoneNumbers",
    },
    {
      header: "EMAIL",
      accessorKey: "Email",
    },
    {
      header: "BILLING ADDRESS",
      accessorKey: "BillingAddress",
    },
    {
      header: "SHIPPING ADDRESS",
      accessorKey: "ShippingAddress",
    },
  ]);

  const defaultColDef = useMemo(() => {
    return {
      sortable: true,
      filter: true,
      resizable: true,
      minWidth: 100,
      flex: 1,
    };
  }, []);

  //Function for downloading pdf of barcodesheet

  //Function for print

  //Function for download

  // const toggleAccordion = (index) => {
  //   setActiveAccordion(activeAccordion === index ? null : index);
  // };

  // const renderAccordionIcon = (index) => {
  //   if (activeAccordion === index) {
  //     return <FontAwesomeIcon icon={faChevronUp} />;
  //   } else {
  //     return <FontAwesomeIcon icon={faChevronDown} />;
  //   }
  // };
  const handleSelectChange = (event) => {
    setSelectedOption(event.target.label);
  };

  //Function for lookup receipt
  const paramObject = useParams();
  const apicall = () => {
    const columnIndex = columns.findIndex(
      (column) => column.accessorKey === sorting[0]?.id
    );
    console.log(
      JSON.stringify(columnFilters) + " columnFilters | ",
      globalFilter + " globalFilter | ",
      pagination.pageIndex + " pagination.pageIndex | ",
      pagination.pageSize + " pagination.pageSize | ",
      columnIndex,
      sorting[0]?.id,
      sorting[0]?.desc === undefined
        ? "desc"
        : (sorting[0]?.desc === true ? "desc" : "asc") + " sorting | ",
      startdate + " startdate | ",
      enddate + " enddate",
      "api Call payload"
    );

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters;

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);
    axios
      .get(
        `${
          config.reportsBaseUrl
        }/reports/customercontactlist?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&pagesize=${
          pagination.pageSize
        }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
          globalFilter === undefined ? "" : globalFilter
        }&groupbycolumn=${selectedOption}&startdate=${startdate}&enddate=${enddate}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("res======>", res);
        console.log(res.data.ResponseData);
        if (res.data.ResponseCode === "SUCCESS") {
          setResponseData(res.data.ResponseData);
          setSelectedOption(res.data.ResponseData);
          setRowCount(res.data.ResponseData[0].TotalRecord);
          console.log("11", responseData);
          //   barcodeRefs.current = responseData;
        }

        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    apicall();
  }, [
    columnFilters,
    globalFilter,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
  ]);

  const onGridReady = useCallback((params) => {
    axios
      .get(
        `${
          config.reportsBaseUrl
        }/reports/customercontactlist?groupbycolumn=${""}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("res======>", res);
        console.log(res.data.ResponseData);
        if (res.data.ResponseCode === "SUCCESS") {
          setResponseData(res.data.ResponseData);
          setSelectedOption(res.data.ResponseData);
          console.log("11", responseData);
          //   barcodeRefs.current = responseData;
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    onGridReady();
  }, [onGridReady]);

  useEffect(() => {
    generateBarcodes();
    console.log("barcodeRefs", barcodeRefs);
    // setLoading(true);
    axios
      .get(
        `${
          config.reportsBaseUrl
        }/reports/customercontactlist?groupbycolumn=${""}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("res======>", res);
        console.log(res.data.ResponseData);
        if (res.data.ResponseCode === "SUCCESS") {
          setResponseData(res.data.ResponseData);
          setSelectedOption(res.data.ResponseData);
          console.log("11", responseData);
          //   barcodeRefs.current = responseData;
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, []);

  //Function for export excel
  const handleExcelExport = () => {
    setLoading(true);
    axios
      .post(
        `${config.salesconfigBaseUrl}/sales/excelexport`,
        {
          salesid: paramObject.id,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log(res);
        toastSuccess(DATA_EXPORT);
        setLoading(false);
      })
      .catch((err) => {
        toastError(ERROR_MESSAGE);
        setLoading(false);
      });
  };

  // to calculate the total
  const calculateTotalSum = () => {
    const sum = responseData.reduce((total, report) => {
      const reportTotal = Number(report.Openingbalance);

      if (typeof reportTotal === "number" && !isNaN(reportTotal)) {
        return total + reportTotal;
      } else {
        return total;
      }
    }, 0);

    setTotalSum(sum);
  };

  useEffect(() => {
    calculateTotalSum();
  }, [responseData]);

  const totalPages = Math.ceil(responseData.length / ITEMS_PER_PAGE);

  // const downloadPDF = () => {

  // setLoading(true);

  //   const doc = new jsPDF();

  //   // Set up table headers
  //   const headers = columns.map((columns) => columns.headerName);
  //   const data = responseData.map((row) =>
  //   columns.map((columns) => row[columns.field])
  //   );

  //   // Generate PDF table
  //   doc.autoTable({ head: [headers], body: data });

  //   // Save PDF file
  //   doc.save("Customer_Contact_List.pdf");
  // };

  // const onBtExport = useCallback(() => {
  //   gridRef.current.api.exportDataAsExcel({
  //     fileName: `Customer_Contact_List_${Moment(currentDate).format(
  //       "DD-MM-YYYY"
  //     )}`,
  //   });
  // }, []);

  // const downloadPDF = (rows, field) => {
  //   let newData = [];
  //   if (field === "selectedrow") {
  //     newData = rows.map((row) => row.original);
  //   } else if (field === "alldata") {
  //     newData = responseData;
  //   }
  //   console.log(newData, "newData");

  //   setLoading(true);
  //   var doc = new jsPDF("p", "pt", "a4");

  //   // Add the header
  //   let headerElement = document.querySelector("#header");
  //   let clonedHeader = headerElement.cloneNode(true);
  //   clonedHeader.style.fontSize = `10px`;
  //   clonedHeader.style.width = "560px";
  //   clonedHeader.style.marginLeft = "15rem";

  //   let content = "";
  //   let startIndex = 1;
  //   let endIndex = 15;

  //   for (var i = 1; i <= Math.ceil(newData.length / 15); i++) {
  //     if (i == 1) {
  //       clonedHeader.style.marginTop = "2rem";
  //     }
  //     if (i > 1) {
  //       clonedHeader.style.marginTop = "19rem";
  //     }
  //     // Printing header
  //     content += " " + clonedHeader.outerHTML;

  //     // Printing table body
  //     content +=
  //       '<table style="font-size: 8px; margin-left: 2rem; margin-top: 2rem; width: 1140px; border: 1px solid #f5f5f5">';
  //     content +=
  //       "<thead><tr style='margin-bottom: 5px'>" +
  //       '<th style="padding: 7px;">No</th>' +
  //       '<th style="padding: 7px;">CustomerName</th>' +
  //       '<th style="padding: 7px;">Date</th>' +
  //       '<th style="padding: 7px; ">TransactionType</th>' +
  //       '<th style="padding: 7px;">Memo</th>' +
  //       '<th style="padding: 7px;">Num</th>' +
  //       '<th style="padding: 7px; ">Amount</th>' +
  //       '<th style="padding: 7px;">OpenBalance</th>' +
  //       '<th style="padding: 7px; ">ModifiedDate</th>' +
  //       '<th style="padding: 7px;">CreatedBy</th>' +
  //       '<th style="padding: 7px;">CreatedDate</th>' +
  //       '<th style="padding: 7px; ">ModifiedBy</th>' +
  //       '<th style="padding: 7px;">Split</th>' +
  //       '<th style="padding: 7px; ">DueDate</th>' +
  //       '<th style="padding: 7px;">Account</th>' +
  //       '<th style="padding: 7px;">VendorMessage</th>' +
  //       '<th style="padding: 7px; ">Terms</th>' +
  //       '<th style="padding: 7px;">Payment Method</th>' +
  //       '<th style="padding: 7px;">Customer ID</th>' +
  //       "</tr></thead>";
  //     content += "<tbody>";

  //     // Loop for printing items based on endIndex
  //     for (let index = startIndex; index <= endIndex; index++) {
  //       if (index <= newData.length) {
  //         content +=
  //           "<tr>" +
  //           '<td style="font-size: 7px; padding: 7px;">' +
  //           index +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px;">' +
  //           newData[index - 1].CustomerName +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px;">' +
  //           moment(newData[index - 1].Date).format('DD-MM-YYYY') +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px; ">' +
  //           newData[index - 1].TransactionType +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px;">' +
  //           newData[index - 1].MemoDescription +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px;">' +
  //           newData[index - 1].Num +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px; ">' +
  //           Number(newData[index - 1].Amount).toFixed(2) +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px; ">' +
  //           newData[index - 1].OpenBalance +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px;">' +
  //           moment(newData[index - 1].ModifiedDate).format('DD-MM-YYYY') +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px;">' +
  //           newData[index - 1].CreatedBy +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px;">' +
  //           moment(newData[index - 1].CreatedDate).format('DD-MM-YYYY') +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px; ">' +
  //           newData[index - 1].ModifiedBy +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px; ">' +
  //           newData[index - 1].Split +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px;">' +
  //           moment(newData[index - 1].DueDate).format('DD-MM-YYYY') +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px;">' +
  //           newData[index - 1].Account +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px; ">' +
  //           newData[index - 1].VendorMessage +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px; ">' +
  //           newData[index - 1].Terms +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px; ">' +
  //           newData[index - 1].PaymentMethod +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px; ">' +
  //           newData[index - 1].CustomerID +
  //           // '<td style="font-size: 7px; padding: 7px; ">' +
  //           // Number(data[index - 1].Balance).toFixed(2) +
  //           // "</td>" +
  //           // '<td style="font-size: 7px; padding: 7px; text-align: right;">' +
  //           // Number(data[index - 1].Amount).toFixed(2) +
  //           // "</td>" +
  //           // '<td style="font-size: 7px; padding: 7px; ">' +
  //           // Number(data[index - 1].Balance).toFixed(2) +
  //           // "</td>" +
  //           "</tr>";
  //       }

  //       if (index % 15 == 0) {
  //         startIndex = startIndex + 15;
  //         endIndex = endIndex + 15;
  //         break;
  //       }
  //     }

  //     content += "</tbody>";
  //     content += "</table>";

  //     // content +=
  //     //   '<div style="text-align: center; width: 560px;  margin-left: 220px">' +
  //     //   '<p style= "text-align: center; margin-top: 1.3rem; font-size: 9px; font-weight: bold;">' +
  //     //   i +
  //     //   "</p>" +
  //     //   "</div>";
  //   }

  //   // Printing page
  //   doc.html(content, {
  //     callback: function (pdf) {
  //       pdf.save("Customer_Contact_List.pdf");
  //       setLoading(false);
  //     },
  //   });
  // };

  const downloadPDF = (rows, field) => {
    let newData = [];
    if (field === "selectedrow") {
      newData = rows.map((row) => row.original);
    } else if (field === "alldata") {
      newData = responseData;
    }
    console.log(newData, "newData");

    // setLoading(true);
    var doc = new jsPDF("p", "pt", "a4");

    // Add the header
    let headerElement = document.querySelector("#header");
    let clonedHeader = headerElement.cloneNode(true);
    clonedHeader.style.fontSize = `10px`;
    clonedHeader.style.width = "560px";
    clonedHeader.style.margin = "1rem";

    let content = "";
    let startIndex = 1;
    let endIndex = 25;

    for (var i = 1; i <= Math.ceil(newData.length / 25); i++) {
      if (i == 1) {
        clonedHeader.style.marginTop = "2rem";
      }
      if (i > 1) {
        clonedHeader.style.marginTop = "2.5rem";
      }
      // Printing header
      content += " " + clonedHeader.outerHTML;

      // Printing table body
      content +=
        '<table style="font-size: 8px; margin-left: 1rem; margin-top: 2rem; width: 560px; border: 1px solid #f5f5f5">';
      content +=
        "<thead><tr style='margin-bottom: 5px'>" +
        '<th style="padding: 7px;">No</th>' +
        '<th style="padding: 7px;">Customer</th>' +
        '<th style="padding: 7px;">Phone Numbers</th>' +
        '<th style="padding: 7px;">Email</th>' +
        '<th style="padding: 7px;">Billing Address</th>' +
        '<th style="padding: 7px;">Shipping Address</th>' +
        "</tr></thead>";
      content += "<tbody>";

      // Loop for printing items based on endIndex
      for (let index = startIndex; index <= endIndex; index++) {
        if (index <= newData.length) {
          content +=
            "<tr>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            index +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            newData[index - 1].Customer +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            newData[index - 1].PhoneNumbers +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            newData[index - 1].Email +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            newData[index - 1].BillingAddress +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            newData[index - 1].ShippingAddress +
            "</td>" +
            "</tr>";
        }
        if (index % 25 == 0) {
          startIndex = startIndex + 25;
          endIndex = endIndex + 25;
          break;
        }
      }

      content += "</tbody>";
      content += "</table>";

      content +=
        '<div style="text-align: center; width: 560px">' +
        '<p style= "text-align: center; margin-top: 1.3rem; font-size: 9px; font-weight: bold;">' +
        i +
        "</p>" +
        "</div>";
    }

    // Printing page
    doc.html(content, {
      callback: function (pdf) {
        pdf.save("Customer_contact_List.pdf");
        setLoading(false);
      },
    });
  };

  const onBtExport = () => {
    const workbook = XLSX.utils.book_new();

    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(responseData);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `CustomerContactList_.xlsx`);
  };

  const setPrinterFriendly = (api) => {
    const eGridDiv = document.querySelector("#myGrid");
    eGridDiv.style.width = "";
    eGridDiv.style.height = "";
    api.sizeColumnsToFit();
    // api.sizeColumnsToFit();
    api.setDomLayout("print");
  };

  const onBtPrint = useCallback(() => {
    const doc = new jsPDF();

    // Get the specific ag-Grid instance by its grid ID
    const api = gridRef.current.api;

    // Create a printer-friendly view for the specific ag-Grid
    const eGridDiv = document.querySelector("#myGrid");
    eGridDiv.style.width = "100%"; // Adjust as needed
    eGridDiv.style.height = "100%"; // Adjust as needed
    api.sizeColumnsToFit();
    api.setDomLayout("print");

    // Wait for the grid to finish rendering, then create a PDF from the HTML content
    setTimeout(function () {
      html2canvas(eGridDiv, { scale: 2 }).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        doc.addImage(imgData, "PNG", 10, 10, 190, 0);
        doc.autoTable({ html: "#myGrid" });
        doc.save("agGrid.pdf");
      });
    }, 2000); // Adjust the delay as needed
  }, []);

  const handleExportRows = (rows) => {
    console.log(
      rows.map((row) => row.original),
      "selected row"
    );
    // csvExporter.generateCsv(rows.map((row) => row.original));

    const workbook = XLSX.utils.book_new();
    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(rows.map((row) => row.original));
    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `CustomerContactList_.xlsx`);
  };

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row" style={{ marginTop: "5px" }}>
              <h3 className="page-title">Customer Contact List</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/report">Report</Link>
                </li>
                <li className="breadcrumb-item active">
                  Customer Contact List
                </li>
              </ul>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-4 mt-4">
              <div className="form-group row">
                <label className="col-form-label col-md-3 form-label">
                  Group by
                </label>
                <div className="col-md-9">
                  <select
                    className="form-control custom-search-select"
                    name="groupby"
                    id="groupby"
                    value={selectedOption}
                    onChange={(e) => {
                      setSelectedOption(e.target.value);
                      console.log("xyz23", e.target.value);
                    }}
                  >
                    <option value="">None</option>
                    <option value="CITY">Shipping City</option>
                    <option value="STATE">Shipping State</option>
                    <option value="ZIP">Shipping Zip</option>
                    <option value="CITY">Billing City</option>
                    <option value="STATE">Billing State</option>
                    <option value="ZIP">Billing Zip</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div style={{ display: "flex" }}>
            <button
              type="submit"
              className="btn btn-sm btn-primary pull-right mb-3 w-25 mt-0"
              style={{ marginLeft: "auto" }}
              onClick={apicall}
            >
              Generate Report
            </button>
          </div>

          {/* Receipt */}

          <div className="card mt-5" id="print">
            <div className="card-body">
              <div className="container">
                <div className="col-md-12 text-center" id="header">
                  <h2>SonarPos</h2>
                  <p className="fw-bold">Customer Contact List</p>
                </div>
              </div>
              <hr />
              <div className="table-responsive">
                <div className="table mt-3">
                  {/* <thead className="border 1px solid white">
                    <tr>
                      <th>CUSTOMER</th>
                      <th>PHONE NUMBERS</th>
                      <th>EMAIL</th>
                      <th>FULL NAME</th>
                      <th>BILLING ADDRESS</th>
                      <th>SHIPPING ADDRESS</th>
                    </tr>
                  </thead>
                  <tbody>
                    {responseData?.map((report, index) => {
                      return (
                        <React.Fragment key={index}>
                          <tr onClick={() => toggleAccordion(index)}>
                            <td colSpan="6">
                              {renderAccordionIcon(index)} &nbsp;
                              {report.Customername}
                            </td>
                          </tr>
                          {activeAccordion === index && (
                            <tr>
                              <td>{report.Customer}</td>
                              <td>{report.PhoneNumbers}</td>
                              <td>{report.Email}</td>
                              <td>{report.Customer}</td>
                              <td>{report.BillingAddress}</td>
                              <td>{report.ShippingAddress}</td>
                            </tr>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </tbody> */}
                  {/* <div className="button">
                    <button
                      onClick={onBtExport}
                      className="btn btn-sm btn-outline-dark  m-1"
                      // style={{ marginBottom: '5px',marginLeft: "5px", fontWeight: 'bold' }}
                    >
                      Export to Excel
                    </button>
                    <button
                      onClick={downloadPDF}
                      className="btn btn-sm btn-outline-dark  m-1"
                      // style={{ marginBottom: '5px',marginLeft: "5px", fontWeight: 'bold' }}
                    >
                      Export to Pdf
                    </button>
                    <button
                      className="btn btn-sm btn-outline-dark  m-1"
                      onClick={onBtPrint}
                    >
                      Print
                    </button>
                  </div> */}

                  <div className="grid-wrapper">
                    {/* <div  id="myGrid" className="ag-theme-alpine">
              <AgGridReact
              ref={gridRef}
              rowData={responseData}
              columnDefs={columnDefs}
              defaultColDef={defaultColDef}
              onGridReady={onGridReady}
              // onFirstDataRendered={onFirstDataRendered}
              // pagination={true}
            ></AgGridReact>
          </div> */}
                    <div>
                      <MaterialReactTable
                        muiTableContainerProps={{
                          sx: { maxHeight: "fit-content" },
                        }}
                        columns={columns}
                        data={responseData}
                        enableColumnResizing
                        enableGrouping
                        enableStickyHeader
                        enableStickyFooter
                        enableRowSelection
                        enableColumnOrdering
                        initialState={{
                          density: "compact",
                          expanded: true, //expand all groups by default
                          // grouping: [""], //an array of columns to group by by default (can be multiple)
                          pagination: { pageIndex: 0, pageSize: 25 },
                          // sorting: { id: "Name", desc: false }, //sort by state by default
                        }}
                        // muiToolbarAlertBannerChipProps={{ color: "primary" }}
                        // muiTableContainerProps={{ sx: { maxHeight: 700 } }}
                        muiTablePaginationProps={{
                          rowsPerPageOptions: [50, 100, 300, 500],
                        }}
                        manualFiltering
                        manualPagination
                        manualSorting
                        muiToolbarAlertBannerProps={
                          isError
                            ? {
                                color: "error",
                                children: "Error loading data",
                              }
                            : undefined
                        }
                        onColumnFiltersChange={setColumnFilters}
                        onGlobalFilterChange={setGlobalFilter}
                        onPaginationChange={setPagination}
                        onSortingChange={setSorting}
                        rowCount={rowCount}
                        // enableColumnVirtualization={false}
                        // enableColumnVirtualization
                        state={{
                          columnFilters,
                          globalFilter,
                          isLoading,
                          pagination,
                          showAlertBanner: isError,
                          showProgressBars: isRefetching,
                          sorting,
                        }}
                        renderTopToolbarCustomActions={({ table }) => (
                          <Box
                            sx={{
                              display: "flex",
                              gap: "1rem",
                              p: "0.5rem",
                              flexWrap: "wrap",
                            }}
                          >
                            <Button
                              size="small"
                              color="primary"
                              //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                              onClick={onBtExport}
                              startIcon={<FileDownloadIcon />}
                              variant="contained"
                            >
                              Export All In Excel
                            </Button>
                            <Button
                              size="small"
                              disabled={
                                !table.getIsSomeRowsSelected() &&
                                !table.getIsAllRowsSelected()
                              }
                              //only export selected rows
                              onClick={() =>
                                handleExportRows(
                                  table.getSelectedRowModel().rows
                                )
                              }
                              startIcon={<FileDownloadIcon />}
                              variant="contained"
                            >
                              Export Selected Rows in Excel
                            </Button>
                            <Button
                              size="small"
                              color="primary"
                              //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                              onClick={() => downloadPDF("", "alldata")}
                              startIcon={<FileDownloadIcon />}
                              variant="contained"
                            >
                              Export All In Pdf
                            </Button>
                            <Button
                              size="small"
                              disabled={
                                !table.getIsSomeRowsSelected() &&
                                !table.getIsAllRowsSelected()
                              }
                              //only export selected rows
                              onClick={() =>
                                downloadPDF(
                                  table.getSelectedRowModel().rows,
                                  "selectedrow"
                                )
                              }
                              startIcon={<FileDownloadIcon />}
                              variant="contained"
                            >
                              Export Selected Rows in Pdf
                            </Button>
                            {/* <Button
                              size="small"
                              onClick={() =>
                                // setPagination({ ...pagination, pageSize: totalRows })
                                setPagination({
                                  ...pagination,
                                  pageIndex: 0,
                                  pageSize: rowCount,
                                })
                              }
                              variant="contained"
                            >
                              Get All Data
                            </Button> */}
                          </Box>
                        )}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 text-center">
                  {/* <h6>
                    {" "}
                    {currentDate.toLocaleString()} &nbsp;GMT Time: {hours}:
                    {minutes}
                  </h6> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={{ display: "none" }}>
        {responseData.map((item) => (
          <>
            {/* <button onClick={console.log("item", item)}>click me</button> */}
            <div key={item.SaleId}>
              <canvas
                data-name={item.SaleId}
                ref={(el) => (barcodeRefs.current[item.SaleId] = el)}
                id={`barcode-${item.SaleId}`}
              />
            </div>
          </>
        ))}
      </div>
    </>
  );
};

export default CustomerContactList;

// import React from "react";
// import DataTable from "react-data-table-component";

// function YourComponent() {
//   const data = [
//     { id: 1, name: "John Doe", age: 28 },
//     { id: 2, name: "Jane Smith", age: 32 },
//     // Add more data rows as needed
//   ];

//   const columns = [
//     { name: "ID", selector: "id", sortable: true },
//     { name: "Name", selector: "name", sortable: true },
//     { name: "Age", selector: "age", sortable: true },
//     // Add more columns as needed
//   ];

//   const expandableRows = ({ data }) => (
//     <div>
//       <p>Additional details:</p>
//       <ul>
//         <li>ID: {data.id}</li>
//         <li>Name: {data.name}</li>
//         <li>Age: {data.age}</li>
//         {/* Add more details as needed */}
//       </ul>
//     </div>
//   );

//   return (
//     <DataTable
//       title="Your DataTable"
//       columns={columns}
//       data={data}
//       expandableRows
//       expandableRowsComponent={expandableRows}
//     />
//   );
// }

// export default YourComponent;
